import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { UtmService } from '@common/services';
import { NavigationService } from '@modules/navigation/services';
import { filter, take } from 'rxjs';

@Component({
    selector: 'sbf-social-redirect',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './social-redirect.component.html',
    styleUrls: ['social-redirect.component.scss'],
})
export class SocialRedirectComponent implements OnInit {
    constructor(
        private navigationService: NavigationService,
        private utmService: UtmService,
        private router: Router,
        private activatedRoute: ActivatedRoute
    ) {
        this.navigationService
            .currentURLPathOnly$()
            .pipe(
                filter((value) => !!value),
                take(1)
            )
            .subscribe((currentURLPath) => {
                const source =
                    activatedRoute.snapshot.queryParamMap.get('utm_source') ||
                    currentURLPath.replace('/', '');
                const medium = activatedRoute.snapshot.queryParamMap.get('utm_medium') || 'social';
                const campaign = activatedRoute.snapshot.queryParamMap.get('utm_campaign');
                const content = activatedRoute.snapshot.queryParamMap.get('utm_content');
                const term = activatedRoute.snapshot.queryParamMap.get('utm_term');

                this.utmService.utm = {
                    source,
                    medium,
                    campaign,
                    content,
                    term,
                    transactionId: null,
                    offerId: null,
                };
                this.router.navigate([`/`]);
            });
    }
    ngOnInit() {}
}
